import { render, staticRenderFns } from "./SpecialSpecialtyBtns.vue?vue&type=template&id=87533372&"
import script from "./SpecialSpecialtyBtns.vue?vue&type=script&lang=js&"
export * from "./SpecialSpecialtyBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports